import styled from "@yb/styled-px2rem";
import imgButton from "@PUBLIC/M/images/btn/btn_spr.png";
import PopupCloseButton from "./PopupCloseButton";
import TextButton from "./TextButton";
import ResetButton from "./ResetButton";
import TextMoreButton from "./TextMoreButton";
import BackButton from "./BackButton";
import NumberButton from "./NumberButton";
import CountingButton from "./CountingButton";
import TextDefaultButton from "./TextDefaultButton";

const WishListButton = styled.button<{isActive: boolean}>`
	width: 14px;
	height: 12px;
	background-image: url(${imgButton});
	background-size: 100px 100px;
	background-color: transparent;
	background-position: ${props => (props.isActive ? "-31px 0px;" : "-16px 0px")};
	z-index: 1;
`;

const ShareButton = styled.button`
	width: 15px;
	height: 15px;
	background: transparent url(${imgButton}) -30px -18px / 100px 100px;
	z-index: 1;
	margin-left: 10px;
`;

const ProductCheck = styled.input`
	position: absolute;
	top: 15px;
	left: 15px;
	z-index: 1;
	display: block;
	width: 26px;
	height: 21px;
	margin: 0;
	box-sizing: border-box;
	background: transparent url(${imgButton}) 0 -34px / 100px 100px;
	border: none;
	vertical-align: middle;

	&:focus {
		border: none;
		background: transparent url(${imgButton}) 0 -34px / 100px 100px;
	}
`;

const OptionItemButton = styled.div`
	input[type="checkbox"] {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}

	label {
		display: block;
		padding: 9px 16px;
		border-radius: 18px;
		border: 1px solid var(--line-color);
		background-color: #fff;
		font-size: 15px;
		color: var(--default-color);
		line-height: 1;
		cursor: pointer;
	}

	input[type="checkbox"]:checked + label {
		border: 1px solid var(--blue-color);
		background-color: var(--blue-color);
		font-weight: bold;
		color: #fff;
	}
`;

export {
	WishListButton,
	ShareButton,
	ProductCheck,
	PopupCloseButton,
	TextButton,
	ResetButton,
	OptionItemButton,
	TextMoreButton,
	BackButton,
	NumberButton,
	CountingButton,
	TextDefaultButton,
};
export {default as PlusMoreButton} from "./PlusMoreButton";
